import { Component, inject, Input } from '@angular/core';
import { ControlContainer, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { HotToastService } from '@ngxpert/hot-toast';
import { MaterialModule } from '../../../../../shared/material.module';

@Component({
  selector: 'app-keyword-input',
  imports: [ReactiveFormsModule, MaterialModule],
  templateUrl: './keyword-input.component.html',
  styleUrl: './keyword-input.component.scss',
  viewProviders: [
    { provide: ControlContainer, useFactory: () => inject(ControlContainer, { skipSelf: true }) }
  ]
})
export class KeywordInputComponent {
  @Input({ required: true }) name!: string;
  @Input() label = '';
  @Input() appearance: 'fill' | 'outline' = 'fill';
  @Input() fieldClass = 'form-field';

  private toast = inject(HotToastService);
  private controlContainer = inject(ControlContainer);

  get currentValue(): string {
    const parent = this.controlContainer.control as FormGroup | null;
    const v = parent?.get(this.name)?.value;
    return typeof v === 'string' ? v : '';
  }

  copy(value: string): void {
    if (!value) return;
    navigator.clipboard.writeText(value).then(
      () => this.toast.success('Copied to clipboard'),
      () => this.toast.error('Failed to copy to clipboard')
    );
  }
}
